const $$splitComponentImporter = () => import('/home/ubuntu/actix-web-dome/ui/src/apps/main/routes/_main/user/app/$appId/features-rbac/audit.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { AuditListFilterParamSchema } from '@apps/main/features/user/pages/app/detail/feature-rbac/audit-schema';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_main/user/app/$appId/features-rbac/audit')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: AuditListFilterParamSchema
});